module.exports = __webpack_public_path__ + "static/Silvia-Santini-c9686eca799f8361b895920d034d06ff.jpg";